<template>
  <div class="row">
    <div class="col-md-12 text-right">
      <app-spinner v-if="isLoading"></app-spinner>
      <template v-else>
        <el-button @click="confirmationBox"
                   :disabled="!canShowCancel || !canModifyOrder"
                   type="danger" class="pull-left">Cancel Order
        </el-button>

        <el-button @click="recalculate"
                   :disabled="$v.products.$invalid || !canModifyOrder"
                   type="primary">Recalculate Payment
        </el-button>
        <el-button @click="createDraftOrder"
                   :disabled="disabled || !canModifyOrder"
                   type="success">Create Draft Order
        </el-button>
      </template>
      <el-dialog :visible.sync="isOrderCancelAlertVisible" width="30%">
        <template>
          <h4 style="text-align: left">Warning!!! Please confirm the cancellation of this order?</h4>
        </template>
        <span slot="footer" class="dialog-footer">
        <el-button class="m-b-1" @click="handleConfirmationBoxNo">
          No
        </el-button>
        <el-button type="danger" @click="handleConfirmationBoxYes">
          Yes
        </el-button>
      </span>
      </el-dialog>
      <p v-if="areProductsInvalid" class="text-danger">
        Some of the selected line item(s) is invalid. Please review selection.
      </p>
      <p v-if="hasProductQuantityWarning" class="text-warning">
        Some of the selected line item(s) have an <strong>invalid quantity</strong>.
        If this is unexpected, then please review selection.
      </p>
      <p v-if="!$v.payment.totalPrice.maxValue" class="text-danger">
        The total price exceeds the maximum eligible amount.
      </p>
      <p v-if="!$v.payment.totalPrice.minValue" class="text-danger">
        There is something wrong with the Total, please recalculate
        payment. If problem persists then please contact administrator.
      </p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import AppSpinner from '../../ui/AppSpinner';
import {ORDER_CANCEL, ORDER_DRAFT_SAVE, ORDER_PAYMENT_REFRESH,} from '../../../store/types';
import {D365_STATUS_INVOICED} from "../../../lang/en/constants";

export default {
  name: 'OrderSave',
  inject: ['$v'],
  components: {
    AppSpinner,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      refreshPayment: ORDER_PAYMENT_REFRESH,
      createDraftOrder: ORDER_DRAFT_SAVE,
      cancelOrder: ORDER_CANCEL,
    }),
    recalculate: function () {
      this.refreshPayment().then(() => {
        this.$v.$reset();
      });
    },
    confirmationBox() {
      this.isOrderCancelAlertVisible = true;
    },
    handleConfirmationBoxYes() {
      this.isOrderCancelAlertVisible = false;
      this.cancelOrder();
    },
    handleConfirmationBoxNo() {
      this.isOrderCancelAlertVisible = false;
      this.warehouseModel = true;
    },
  },
  computed: {
    ...mapState({
      draftOrder: state => state.order.draftOrder,
      products: state => state.order.products.items,
      region: state => state.order.region,
      canModifyOrder: state => state.order.order.fulfillment_status === null,
    }),
    disabled: function () {
      return this.$v.$invalid || this.$v.$anyDirty || this.draftOrder ===
          null;
    },
    canShowCancel: function () {
      return this.region === 'ca' || this.region === 'usa';
    },
    areProductsInvalid() {
      return this.$v.products.$invalid;
    },
    hasProductQuantityWarning() {
      return this.products.reduce((sum, product) => {
        if (product.variant.size) {
          sum += product.quantity > product.variant.size.inventory;
        }

        return sum;
      }, 0) > 0;
    },
  },
  data() {
    return {
      isOrderCancelAlertVisible: false,
    };
  },
};
</script>
